// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchNavbarComponents-cls1_y4E","cls2":"SearchNavbarComponents-cls2_0CH SearchNavbarComponents-cls1_y4E"};